import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { CircularProgress, TextField } from '@material-ui/core'

import { Button } from 'ui/components'
import DataTable from 'ui/components/ContainerCommonPanels/DataTable'

import { getPlans } from 'services/apiMotorBgc'
import reportError from 'utils/errorReporter'
import { PANEL_ENVS } from 'utils/constants/environments'

import ButtonPlanCreate from './ButtonPlanCreate'
import ButtonPlanDelete from './ButtonPlanDelete'
import ButtonPlanEdit from './ButtonPlanEdit'
import ButtonPlanView from './ButtonPlanView'
import ButtonUserDefineDefaultPlan from './ButtonUserDefineDefaultPlan'
import { columnsPlans } from './configDataTable'

import styles from './styles'

export default function ({
  docType,
  onSelectPlan,
  showBtnCreate = false,
  showBtnDelete = false,
  showBtnEdit = false,
  showBtnSelect = false,
  showBtnUserDefineDefaultPlan = false,
  showBtnView = false,
  visibleToOrganization,
}) {
  const classes = styles()

  const apiKey = useSelector((state) => state.auth.api_key)
  const userId = useSelector((state) => state.auth.sub)
  const myUserEmail = useSelector((state) => state.user.email)
  const userConfig = useSelector((state) => state.user.config)

  let planDefault = null
  switch (docType) {
    case PANEL_ENVS.CPF:
      planDefault = userConfig.default_plan_cpf
      break
    case PANEL_ENVS.CNPJ:
      planDefault = userConfig.default_plan_cnpj
      break
    default:
  }

  const [loading, setLoading] = useState(false)
  const [searchName, setSearchName] = useState('')
  const [plans, setPlans] = useState([])
  const [pageData, setPageData] = useState({ current: 1, totalItems: 0, totalPages: 0, perPage: 0 })

  const fetchPlans = async (options = {}) => {
    setLoading(true)

    let res = null
    try {
      res = await getPlans(
        apiKey,
        userId,
        docType,
        {
          name: options.name,
          visible_to_organization: visibleToOrganization,
          page: _.has(options, 'page') ? options.page : pageData.current,
        },
      )
    } catch (err) {
      reportError(err, 'Erro ao obter os planos')
      setLoading(false)
      return
    }

    const current = parseInt(res.headers['x-page'], 10)
    const totalItems = parseInt(res.headers['x-total'], 10)
    const perPage = parseInt(res.headers['x-per-page'], 10)
    const totalPages =  Math.ceil(totalItems / perPage)
    setPageData({ current: current, totalPages: totalPages, totalItems: totalItems, perPage: perPage })
    setPlans(res.data.plans)
    setLoading(false)
  }

  useEffect(() => {
    fetchPlans({ page: 1 })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handlePlanCreate = () => {
    setSearchName('')
    fetchPlans({ page: 1 })
  }

  const handlePlanDelete = () => {
    setSearchName('')
    fetchPlans({ page: 1 })
  }

  const handlePlanEdit = () => {
    setSearchName('')
    fetchPlans({ page: 1 })
  }

  const handleSearchName = () => {
    fetchPlans({ name: searchName, page: 1 })
  }

  const handleChangePage = (number) => {
    fetchPlans({ name: searchName, page: number + 1 })
  }

  const renderButtonSelectPlan = (plan) => {
    if (!showBtnSelect) return null

    return (
      <Button
        variant="outlined"
        size="small"
        onClick={() => onSelectPlan(plan)}
      >
        Selecionar
      </Button>
    )
  }

  const renderButtonViewPlan = (plan) => {
    if (!showBtnView) return null

    return (
      <ButtonPlanView
        docType={docType}
        planId={plan.plan_id}
      />
    )
  }

  const renderButtonUserDefineDefaultPlan = (plan) => {
    if (!showBtnUserDefineDefaultPlan) return null

    return (
      <ButtonUserDefineDefaultPlan
        docType={docType}
        plan={plan}
      />
    )
  }

  const renderButtonDeletePlan = (plan) => {
    if (!showBtnDelete) return null
    if (myUserEmail !== plan.user_email) return null

    return (
      <ButtonPlanDelete
        docType={docType}
        plan={plan}
        onSubmit={handlePlanDelete}
      />
    )
  }

  const renderButtonEditPlan = (plan) => {
    if (!showBtnEdit) return null
    if (myUserEmail !== plan.user_email) return null

    return (
      <ButtonPlanEdit
        docType={docType}
        plan={plan}
        onSubmit={handlePlanEdit}
      />
    )
  }

  const renderPlanActions = (plan) => {
    return (
      <div>
        {renderButtonSelectPlan(plan)}
        {renderButtonViewPlan(plan)}
        {renderButtonUserDefineDefaultPlan(plan)}
        {renderButtonEditPlan(plan)}
        {renderButtonDeletePlan(plan)}
      </div>
    )
  }

  const plansWithAction = () => {
    return _.map(plans, (plan) => {
      const newPlan = _.cloneDeep(plan)
      newPlan.action = renderPlanActions(plan)
      if (newPlan.plan_id === planDefault.plan_id) newPlan.name += " (PLANO PADRÃO)"

      return newPlan
    })
  }

  const renderPlans = () => {
    if (loading) return <CircularProgress />

    return (
      <DataTable
        columns={columnsPlans}
        data={plansWithAction()}
        options={{
          pagination: true,
          serverSide: true,
          rowsPerPage: pageData.perPage,
          count: pageData.totalItems,
          page: pageData.current - 1,
          sort: false,
          onChangePage: handleChangePage,
        }}
      />
    )
  }

  const renderButtonPlanCreate = () => {
    if (!showBtnCreate) return null

    return (
      <div className={classes.buttonPlanCreate}>
        <ButtonPlanCreate docType={docType} onSubmit={handlePlanCreate} />
      </div>
    )
  }

  const renderFilterName = () => {
    return (
      <div className={classes.buttonFilterName}>
        <TextField label="Nome" value={searchName} onChange={(e) => setSearchName(e.target.value)} />
        <Button variant="text" onClick={handleSearchName}>Filtrar</Button>
      </div>
    )
  }

  return (
    <div>
      <div className={classes.buttonsContainer}>
        {renderButtonPlanCreate()}
      </div>
      {renderFilterName()}
      {renderPlans()}
    </div>
  )
}
